"use client";

import React from "react";
import { usePathname } from "next/navigation";

export default function FiltersMobileButton({ name = "Results" }) {
  const pathname = usePathname();
  const handleFilterButtonClick = () => {
    const filter = document.getElementById("AWS_Facets");
    const overlay = document.getElementsByClassName("js-off-canvas-overlay")[1];
    const filterButton = document.getElementById("filterButton");
    const open = filter.classList.contains("is-open");

    if (!open) {
      filter.classList.add("is-open");
      filter.classList.remove("is-closed");
      filter.attributes["aria-hidden"].value = "false";
      filterButton.attributes["aria-expanded"].value = "true";
      overlay.classList.add("is-visible");
      overlay.classList.add("is-closable");
    } else {
      filter.classList.add("is-closed");
      filter.classList.remove("is-open");
      filter.attributes["aria-hidden"].value = "true";
      filterButton.attributes["aria-expanded"].value = "false";
      overlay.classList.remove("is-visible");
      overlay.classList.remove("is-closable");
    }
  };

  return (
    <button
      id="filterButton"
      type="button"
      className="button tps-button-no-icon hide-for-xlarge "
      data-toggle="AWS_Facets"
      aria-expanded="false"
      aria-controls="AWS_Facets"
      onClick={() => handleFilterButtonClick()}
    >
      <span aria-hidden="true" className="tps-icon fal fa-sliders-h"></span>
      Filter {name}
    </button>
  );
}
